module.exports = __webpack_public_path__ + "images/5268ba65886115ad9649a9a3d16d68374.svg";